import React, { useContext, useEffect, useRef } from 'react';
import { observer } from 'mobx-react';

import * as S from './Dock.style';

import { RootStoreContext } from '../../App';

import DockLikuConnect from './liku/DockLikuConnect';

import DockLikuMusic from './liku/DockLikuMusic';
import { useClick } from '../../hooks/useClick';
import DockLikuUnConnect from './liku/DockLikuUnConnect';
import DockLikuController from './liku/controller/DockLikuController';
import DockLikuConnecting from './liku/DockLikuConnecting';

const Dock = observer(() => {
	const {
		likuStore,
		mqttStore,
		contentStore,
		contentV2Store,
		interactiveStore,
		metaverseStore,
		birthdayStore,
	} = useContext(RootStoreContext);

	const music = useClick(false);
	const controller = useClick(false);

	const musicButtonRef = useRef(null);
	const controllerButtonRef = useRef(null);
	const isContentPlaying = [
		contentStore,
		contentV2Store,
		interactiveStore,
		metaverseStore,
		birthdayStore,
	].some((store) => store?.isStart);

	useEffect(() => {
		if (!isContentPlaying) return;
		controller.onClick(false);
		music.onClick(false);
		// useClick returns new controller/music objects on each render.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isContentPlaying]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				music.click && // 추가!
				musicButtonRef.current &&
				!musicButtonRef.current.contains(event.target)
			) {
				music.onClick(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [music]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				controllerButtonRef.current &&
				!controllerButtonRef.current.contains(event.target)
			) {
				console.log('[TEST]', controller.click);
				controller.onClick(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [controller]);

	return (
		<S.Container>
			<S.Content
				thisLiku={likuStore.thisLiku}
				onClick={() => {
					console.log('docker click');
				}}>
				{likuStore.thisLiku ? (
					mqttStore.likuHeartBeat?.isHeartBeat ? (
						<>
							<S.ControllerWrapper
								ref={controllerButtonRef}
								isVisible={controller.click}>
								<DockLikuController
									controller={controller}
									isVisible={controller.click}
								/>
							</S.ControllerWrapper>

							<S.MusicWrapper ref={musicButtonRef} isVisible={music.click}>
								<DockLikuMusic music={music} isVisible={music.click} />
							</S.MusicWrapper>

							<DockLikuConnect
								controller={controller}
								music={music}
								isContentPlaying={isContentPlaying}
							/>
						</>
					) : (
						<DockLikuConnecting />
					)
				) : (
					<DockLikuUnConnect />
				)}
			</S.Content>
		</S.Container>
	);
});

export default Dock;
